import type { PreflightResult } from '@ctcells/contract'
import { REQUEST_TIMEOUT_MS } from '@ctcells/core'

import { orchestrator } from '../clients.ts'
import { keys } from '../keys.ts'
import { createQuery, type SkippableArgs } from '../query.ts'

/**
 * **Pre-flight 스냅샷** — 「왜 시작이 안 되나」를 보이는 자리가 읽는다(`ui/shell/useStartBlockers`).
 *
 * ⚠ 새 패턴 한 줄: `POST` 를 **조회**로 부른다. GET 이 없고, 서버가 이 경로를 «상태를 바꾸지
 *   않는다 · 감사 대상 아님 · 제어락 불필요»로 적었다(`views/batches.py` `preflight_batch`).
 *   같은 경로의 명령 훅(`usePreflightBatch`)은 [시작] 흐름용이고, 이것은 표시용이라 캐시에 둔다.
 * 🔴 **폴링이 아니다**(DP-01). 키가 `keys.batches.detail(id)` **밑**이라 구독 무효화(배치 전이 ·
 *    모듈 상태 · 락 거절 → `keys.batches.all()`)와 [시작]의 사전 점검(`usePreflightBatch` 가
 *    `detail(id)` 를 무효화한다)이 지나갈 때만 다시 잰다.
 * ⚠ 서버가 `WRITE_ROLES` 로 막는다 — viewer 는 403 이다. 부르는 쪽이 `skip` 으로 거른다.
 */
export const usePreflightSnapshot = createQuery<
  { batchId: string | undefined } & SkippableArgs,
  PreflightResult
>({
  key: ({ batchId }) => [...keys.batches.detail(batchId ?? ''), 'preflight'],
  fetch: ({ batchId }) =>
    orchestrator.request<PreflightResult>({
      method: 'POST',
      path: `/batches/${String(batchId)}/preflight`,
      timeoutMs: REQUEST_TIMEOUT_MS.query,
      retryOn401: true,
    }),
  enabled: ({ batchId }) => batchId !== undefined && batchId !== '',
})
